import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import ProductOptions from "./components/ProductOptions/ProductOptions.vue";
import ProductChoices from "./components/ProductOptions/ProductChoices.vue";
import ProductVariationPrice from "./components/ProductOptions/ProductVariationPrice.vue";
import ReviewSection from "./components/ReviewComponents/ReviewSection.vue";
import StarRatingInput from "./components/ReviewComponents/StarRatingInput.vue";
import AddToWishlistButton from "./components/WishlistComponents/AddToWishlistButton.vue";

new Vue({
	el: "#addToWishlist",
	store: window.app.store,
	components: { AddToWishlistButton },
	data() {
		return {};
	},
	computed: {},
	methods: {},
});

new Vue({
	el: "#productChoices",
	store: window.app.store,
	components: { ProductChoices },
	data() {
		return {};
	},
	computed: {},
	methods: {},
});

new Vue({
	el: "#productVariationPrice",
	store: window.app.store,
	components: { ProductVariationPrice },
	data() {
		return {};
	},
	computed: {},
	methods: {},
});

new Vue({
	el: "#productOptions",
	store: window.app.store,
	components: { ProductOptions },
	data() {
		return {};
	},
	computed: {},
	methods: {},
});

new Vue({
	el: "#ReviewSection",
	store: window.app.store,
	components: { ReviewSection },
	data() {
		return {};
	},
	computed: {},
	methods: {},
});

/*
new Vue({
    el:'#StarRating',
    store: window.app.store,
    components: {StarRatingInput},
    data(){return {}},
    computed: {},
    methods: {}
});
*/
